export enum KycLevel {
  PERSONAL = 'personal',
  BUSINESS = 'business',
}

export type PaymentRailOptions =
  | 'swift'
  | 'local' // currencycloud specific
  | 'sepa'
  | 'sepa-instant'
  | 'sepa-target-2'
  | 'chaps'
  | 'bacs'
  | 'faster-payments'
  | 'ach'
  | 'wire'
  | 'internal'
  | 'eft'
  | 'npp'
  | 'becs'
  | 'bpay'
  | 'fps'
  | 'rtgs'
  | 'neft'
  | 'imps'
  | 'zengin'
  | 'duitnow'
  | 'giro'
  | 'fast'
  | 'promptpay'
  | 'napas'
  | 'spei'
  | 'fednow'
  | 'fedwire'
  | 'interac'
  | 'certis'
  | 'elixir'
  | 'sic'
  | 'uaefts'
  | 'masav'
  | 'instapay'
  | 'pesonet'
  | 'bi-fast'
  | 'next-day-ach'
  | 'unionpay'
  | 'bahtnet'
  | 'iach'
  | 'npsb'
  | 'slips'
  | 'ibft'
  | 'fawri'
  | 'hofinet';

export enum PaymentStatusScreen {
  PAYMENT_SUCCESS = 'payment-success',
  PAYMENT_DECLINED = 'payment-declined',
  PAYMENT_PROCESSING = 'payment-processing',
  PAYMENT_REQUEST_SENT = 'request-sent-successfully',
  PAYMENT_REQUEST_FAILED = 'request-failed-to-send',
}

export enum InternationalPaymentStatusScreen {
  PAYMENT_SUCCESS = 'intl-payment-success',
  PAYMENT_DECLINED = 'intl-payment-failed',
  PAYMENT_PROCESSING = 'intl-payment-processing',
}

export enum NotificationDeviceOS {
  ANDROID = 'android',
  IOS = 'ios',
}

export enum DocumentMonthsUpdate {
  USER_DEFINED = 'User Defined',
  LAST_MONTH = 'Last Month',
  PREVIOUS_3_MONTHS = 'Previous 3 Months',
  PREVIOUS_6_MONTHS = 'Previous 6 Months',
}

export enum TimeIntervalUnitEnum {
  SECONDS = 'seconds',
  MINUTES = 'minutes',
  HOURS = 'hours',
  DAYS = 'days',
}

export enum DocumentStateContext {
  TRANSACTION_CONTEXT = 'Transaction Context',
  NOTIFICATION_CONTEXT = 'Notification Context',
}

export enum DocumentType {
  CSV = 'csv',
  PDF = 'pdf',
  CONTEXT = 'context',
}

export enum TransactionInitiator {
  NOTIFICATION = 'notification',
  TRANSACTION = 'transaction',
}

export enum DownloadDocumentType {
  SAVINGS_KEY_PRODUCT_INFORMATION = 'Savings Key Product Information',
  SAVINGS_BANK_STATEMENT = 'Savings Bank Statement',
  SAVINGS_ANNUAL_STATEMENT = 'Savings Annual Statement',
  BANK_STATEMENT = 'Bank Statement',
  PROOF_OF_PAYMENT = 'Proof of Payment',
  PROOF_OF_EXCHANGE = 'Proof of Exchange',
  HOLDING_STATEMENT = 'Holding Statement',
}

export enum TemplateTypeEnum {
  PDF = 'pdf',
  EMAIL = 'email',
  SMS = 'sms',
}

export enum StatusEnum {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum ExchangeFixedType {
  BUY = 'buy',
  SELL = 'sell',
}

export enum DownloadDocumentTypeKey {
  KEY_PRODUCT_INFORMATION_PDF = 'key-product-information-pdf',
  SAVINGS_KEY_PRODUCT_INFORMATION_PDF = 'savings-key-product-information-pdf',
  SAVINGS_ANNUAL_STATEMENT_PDF = 'savings-annual-statement-pdf',
  SAVINGS_ACCOUNT_CLOSURE_STATEMENT_PDF = 'savings-account-closure-statement-pdf',
  SAVINGS_BANK_STATEMENT_PDF = 'savings-bank-statement-pdf',
  SAVINGS_BANK_STATEMENT_CSV = 'savings-bank-statement-csv',
  BANK_STATEMENT_PDF = 'bank-statement-pdf',
  BANK_STATEMENT_CSV = 'bank-statement-csv',
  PROOF_OF_PAYMENT_PDF = 'payment-proof-pdf',
  PROOF_OF_PAYMENT_CSV = 'payment-proof-csv',
  PROOF_OF_EXCHANGE_PDF = 'exchange-proof-pdf',
  PROOF_OF_EXCHANGE_CSV = 'exchange-proof-csv',
  HOLDING_STATEMENT_PDF = 'holding-statement-pdf',
}

export enum NotificationChannelEnum {
  EMAIL = 'email',
  SMS = 'sms',
  PUSH = 'push', // this is being used for in-app channel therefore new key is added PUSH_NATIVE to identify notification config for native device only.
  PUSH_NATIVE = 'pushNative',
}

export enum PaymentTypeSelector {
  PAYMENT_REQUESTOR = 'payment-requestor',
  PAYMENT_INITIATOR = 'payment-initiator',
  PAYMENT_APPROVER = 'payment-approver',
}

export enum FeeFrequencyTypeEnum {
  ONE_OFF = 'one-off',
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  QUARTERLY = 'quarterly',
  ANNUALLY = 'annually',
}

export enum FeeUnitChargeTypeEnum {
  PERCENTAGE_WITH_NO_MIN_MAX = 'percentage-with-no-min-max',
  PERCENTAGE_WITH_MIN_MAX = 'percentage-with-min-max',
  PERCENTAGE_WITH_MIN = 'percentage-with-min',
  PERCENTAGE_WITH_MAX = 'percentage-with-max',
  FIXED_FEE = 'fixed-fee',
}

export enum SumsubReviewStatus {
  INIT = 'init',
  PEDNING = 'pending',
  COMPLETED = 'completed',
  QUEUED = 'queued',
  PRECHECKED = 'prechecked',
  ONHOLD = 'onHold',
}

export enum FeeChargeStatusEnum {
  CHARGED = 'charged',
  REVERTED = 'reverted',
  PENDING = 'pending',
  FAILED = 'failed',
  REVERT_FAILED = 'revert_failed',
}

export enum AlertsKey {
  ALERTS = 'alerts',
  INAPP = 'inApp',
  SMS = 'sms',
  PUSH = 'push',
  EMAIL = 'email',
}

export enum AlertStatusFlag {
  ACTIVE = 'active',
  DISABLED = 'disabled',
  MANDATORY = 'mandatory',
  INACTIVE = 'inactive',
}

export enum AlertStatusFlagLabel {
  ACTIVATE = 'Activate',
  DEACTIVATE = 'Deactivate',
}

export enum EntityType {
  PaymentRequest = 'payment-request',
  // Add other entity types here as needed
}

export enum CommentStatusFlag {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum CreateCurrencyAccountTypeAttributesType {
  TRANSFER_ACCOUNT = 'transfer_account',
  DEPOSIT_ACCOUNT = 'deposit_account',
  VARIABLE_ACCOUNT = 'variable_account',
}

export enum DocumentActionType {
  TRANSACTIONS = 'transactions',
  SAVING_ACCOUNTS = 'saving-accounts',
  CURRENT_ACCOUNTS = 'current-accounts',
  CUSTOMER_DOCUMENTS = 'customer-documents',
}

export enum DocumentActionCategoryType {
  ACCOUNT_STATEMENTS = 'account-statements',
  TAX_CERTIFICATE = 'tax-certificates',
  ACCOUNT_DOCUMENTS = 'account-documents',
  RECEIPTS = 'receipts',
  CUSTOMER_DOCUMENTS = 'customer-documents',
}

export enum UploadFileType {
  IMAGE = 'image',
}

export enum FileExt {
  JPEG = 'jpeg',
  JPG = 'jpg',
  PNG = 'png',
  SVG = 'svg',
  GIF = 'gif',
  WEBP = 'webp',
  JSON = 'json',
  XLSX = 'xlsx',
  XLS = 'xls',
  DOC = 'doc',
  DOCX = 'docx',
  PPT = 'ppt',
  PPTX = 'pptx',
  TXT = 'txt',
  PDF = 'pdf',
  CSV = 'csv',
}

export enum NotificationMark {
  READ = 'read',
  SEEN = 'seen',
  UNREAD = 'unread',
  UNSEEN = 'unseen',
}

export enum NotificationMarkChannelEnum {
  EMAIL = 'email',
  SMS = 'sms',
  PUSH = 'push',
  IN_APP = 'in_app',
}

export enum TaskMonitorQueueName {
  SCHEDULED_PAYMENT = 'schedule-payments',
}

export enum TurnstileAction {
  ONBOARDING = 'onboarding',
  LOGIN = 'login',
  GENERATE_OTP = 'generate-otp',
  VERIFY_OTP = 'verify-otp',
}
